const useStyles = {
  itemsList: {
    overflowY: 'auto',
    maxHeight: '165px',
  },
  deviceRowItem: {
    textOverflow: 'ellipsis',
    width: '100%',
    flex: 1,
    overflowX: 'hidden',
    whiteSpace: 'nowrap',
  },
}
export default useStyles
